<template>

    <el-input @input="onSearchInput" @keyup.enter="doSearch" class="header-search-bar"  size="large" v-model="search" placeholder="Search Enquiry/Booking here.." :prefix-icon="Search" clearable >
        <template #append><el-icon v-if="loading" class="is-loading"><Loading /></el-icon><el-icon v-else><Search /></el-icon></template>
    </el-input>
    <ul id="headsearch" v-if="search!='' && dataloaded">
        <li v-if="loading" class="text-center">Please Wait</li>
        <li v-if="searchdata.length==0 && loading==false" class="text-center">No Data Found</li>
        <li  v-for="enquiry in searchdata" @click="viewenquiry(enquiry.encryptedid)">CDM{{enquiry.id}} / {{enquiry.name}} / {{enquiry.email_id}}/ {{enquiry.mobile}} <span class="badge" v-bind:class="{ 'bg-warning': enquiry.status=='Pending' ,'bg-red':enquiry.status=='Closed','bg-success':enquiry.status=='Converted','bg-info':enquiry.status=='InProgress'}">{{enquiry.status}}</span> </li>
    </ul>
</template>

<script>


import {
    ElInput,ElIcon
} from 'element-plus'


import { Search,Loading } from '@element-plus/icons-vue'
export default {
    name: "SearchBox",
    components: { ElInput,Search,ElIcon,Loading },
    data() {
        return {
            loading: false,
            search:'',
            searchdata:[],
            dataloaded:false,
            searchTimer:null
        }
    },
    methods: {
        onSearchInput() {
            clearTimeout(this.searchTimer);
            if (this.search.trim() === '') {
                this.searchdata = [];
                this.dataloaded = false;
                this.loading = false;
                return;
            }
            this.searchTimer = setTimeout(() => {
                this.doSearch();
            }, 350);
        },
        doSearch() {
            const term = this.search.trim();
            if (term === '') {
                this.searchdata = [];
                this.dataloaded = false;
                this.loading = false;
                return;
            }

            let currentObj = this;
            this.loading=true;
            this.dataloaded=false;
            axios.get('/searchenquiry?value=' + encodeURIComponent(term)).then(function (response) {
                currentObj.searchdata = Array.isArray(response.data) ? response.data : [];
                currentObj.loading=false;
                currentObj.dataloaded=true;
            })
                .catch(function () {
                    currentObj.searchdata = [];
                    currentObj.loading=false;
                    currentObj.dataloaded=true;
                });
        },
        viewenquiry(id){

            window.open('/viewenquiry?id='+id, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)
        },
    }
}
</script>

<style scoped>

</style>
